export const FETCH_DASHBOARD_DETAILS_REQUEST =
  "FETCH_DASHBOARD_DETAILS_REQUEST";
export const FETCH_DASHBOARD_DETAILS_SUCCESS =
  "FETCH_DASHBOARD_DETAILS_SUCCESS";
export const FETCH_DASHBOARD_DETAILS_FAILURE =
  "FETCH_DASHBOARD_DETAILS_FAILURE";
